// components/ProceedToPaymentButton.tsx
import React, { useContext } from "react";
import { CurrencyContext } from "../common/CurrencyContext";

interface ProceedToPaymentButtonProps {
  totalAmount: number;
  onClick: () => void;
}

const ProceedToPaymentButton: React.FC<ProceedToPaymentButtonProps> = ({
  totalAmount,
  onClick,
}) => {
  const { currency } = useContext(CurrencyContext);
  return (
    <div className="fixed bottom-20 right-1 z-50">
      <button
        className="bg-[#0033CC] text-white px-6 py-3 text-sm rounded-lg font-semibold shadow-lg hover:bg-[#0029b3] transition flex items-center gap-3"
        onClick={onClick}
      >
        Proceed To Payment <br /> {currency} {totalAmount.toFixed(2)}
      </button>
    </div>
  );
};

export default ProceedToPaymentButton;
